import script from "./footer-social-links.vue?vue&type=script&setup=true&lang=ts"
export * from "./footer-social-links.vue?vue&type=script&setup=true&lang=ts"

import "./footer-social-links.vue?vue&type=style&index=0&id=bf338638&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf338638"]])

export default __exports__